import { Help } from '@mui/icons-material'
import { Paper, styled, Popper, Box, Button, Typography } from '@mui/material'
import React, { useState } from 'react'
import theme from '../../theme/Default'

const StyledDiv = styled('div')(() => ({
  textTransform: 'lowercase',
  fontSize: '1rem'
}))

const StyledBox = styled(Box)(({ theme }) => ({
  border: '2px solid black',
  padding: '0.5rem',
  backgroundColor: theme.palette.background.paper,
  fontWeight: 'bold',
  color: theme.palette.leitura.main
}))

const HourPaper = styled(Paper)(({ theme }) => ({
  color: theme.palette.leitura.contrastText
}))

export default function RegressiveCounter() {
  const now = new Date(
    new Date().toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' })
  )

  const limitDate = new Date(
    new Date().toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' })
  )

  if (now.getDate() > 5) {
    limitDate.setMonth(parseInt(now.getMonth()) + 1)
  }

  const lastDay = new Date(
    `${limitDate.getFullYear()}-${(limitDate.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-05T23:59:59`
  )
  const diffEmMilissegundos = lastDay - now

  function horaDiff() {
    const segundos = Math.floor(diffEmMilissegundos / 1000)

    const minutos = Math.floor(segundos / 60)

    const horas = Math.floor(minutos / 60)

    const dias = Math.floor(horas / 24)

    const segundosRestantes = segundos % 60

    const minutosRestantes = minutos % 60

    const horasRestantes = horas % 24
    setDiasRestantes(dias)
    return `${
      dias > 1 ? dias + ' dias, ' : dias + ' dia'
    }  ${horasRestantes}h ${minutosRestantes}min ${segundosRestantes}s `
  }

  const [hora, setHora] = useState('')
  setTimeout(() => {
    setHora(horaDiff())
  }, 1000)

  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = event => {
    setAnchorEl(anchorEl ? null : event.currentTarget)
  }

  const [diasRestantes, setDiasRestantes] = useState('')

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popper' : undefined
  return (
    <StyledDiv
      sx={{ marginRight: { xs: '0.5rem', md: '1.8rem' } }}
      className="d-flex align-center"
    >
      <Popper sx={{ zIndex: '9999' }} id={id} open={open} anchorEl={anchorEl}>
        <StyledBox
          sx={{
            border: 1,
            p: 1,
            bgcolor: 'background.paper',
            fontWeight: 'bold',
            color: ''
          }}
        >
          {hora}
        </StyledBox>
      </Popper>
      <Button
        sx={{
          display: {
            xs: 'flex',
            md: 'none',
            fontWeight: 'bold',
            fontSize: '1.1rem'
          }
        }}
        aria-describedby={id}
        onClick={handleClick}
      >
        {diasRestantes + 'Dias'}
        <Help fontSize="1rem" />
      </Button>
      <HourPaper
        color="leitura"
        sx={{
          display: { xs: 'none', md: 'block' },
          backgroundColor: theme.palette.leitura.main
        }}
        elevation={0}
      >
        <Typography sx={{ fontWeight: '600' }}>{hora}</Typography>
      </HourPaper>
    </StyledDiv>
  )
}
